import { fetcher } from '../utils'
import { ComponentClientSearchVO, FromProductClientVO } from '@repo/types'
import { GenericAbortSignal } from 'axios'

export default async (
  input: ComponentClientSearchVO,
  page: number,
  offset: number,
  signal: GenericAbortSignal
): Promise<FromProductClientVO[]> => {
  return fetcher(`/api/relationship/client/search/${page}/${offset}`, 'POST', input, undefined, signal)
}
